import React, { useState } from "react";
import { Box, Toolbar, Typography, TextField, Select, FormControl, MenuItem, InputLabel, Button } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";

import Mobileno from "../Component/Mobileno";
import logo from "../Image/logo.png";
import mpcst from "../Image/newmpcst-logo.jpg";
import Footer from "../Component/Footer";
import Header from "../Component/header";
import DesktopFooter from "../Component/Desktopfooter";
import { useLanguage } from "../context/LanguageContext";

const FirstScreen = () => {

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");

  const { language, setLanguage, t } = useLanguage();
  const navigate = useNavigate();
  let { id } = useParams();

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const pageName = "public";

  return (
    <>
      <div className="aboutSection">
      <Header/> 
        <Box>
          <Toolbar>
            <Mobileno />
          </Toolbar>
        </Box>

      </div>

      <DesktopFooter />
      <Footer />
    </>
  );
};

export default FirstScreen;